import { AppLayout } from '@/components/layout/AppLayout';
import { OnboardingTour } from '@/components/shared/OnboardingTour';

export default function App() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        maxWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <AppLayout />
      <OnboardingTour />
    </div>
  );
}
